<template>
  <view-wrapper
    backText="Go to printer list"
    prefix="Edit"
    name="Printer"
    path="printers"
    :value="this.printerToBeEdited.name"
    :showCancel="true"
    :saveFunc="postPrinter"
    :hasChangesBeenMade="hasChangesBeenMade"
    :deleteFunc="deletePrinter"
  >
    <modal
      v-if="showDeleteModal"
      @close="showDeleteModal = false"
      :type="deleteModalType"
      :heading="deleteModalHeading"
      :description="deleteModalText"
    />
    <wrapper class="mb-3" :focus="true">
      <p>Vendor: {{ this.printerToBeEdited.vendor }}</p>
      <p>Model: {{ this.printerToBeEdited.model }}</p>
    </wrapper>

    <wrapper
      :checkForChildFocused="true"
      class="px-5 pt-10 pb-5 mb-3"
      :focus="printerName !== ''"
    >
      <grafokett-input
        v-model="printerName"
        :editable="true"
        labelPlaceholder="Printer name"
      />
    </wrapper>

    <wrapper
      :checkForChildFocused="true"
      class="px-5 pt-10 pb-5 mb-3"
      :focus="ip !== ''"
    >
      <grafokett-input
        v-model="ip"
        :editable="true"
        labelPlaceholder="IP-adress"
      />
    </wrapper>

    <wrapper
      :checkForChildFocused="true"
      class="px-5 pt-10 pb-5 mb-20"
      :focus="port !== ''"
    >
      <grafokett-input
        v-model="port"
        :editable="true"
        labelPlaceholder="Port"
      />
    </wrapper>

    <assign-groups
      class="mt-16 mb-5"
      :groups="availableGroups"
      text="Assign group to this printer"
      v-model="groups"
      :useCheckbox="false"
      @groupAdded="addGroup"
      @removeGroup="removeGroup"
      :key="componentKey"
    />
  </view-wrapper>
</template>

<script>
import AssignGroups from "../components/datacomponents/AssignGroups";
import GrafokettInput from "../components/forms/Input.vue";
import Modal from "../components/Modal";

export default {
  components: {
    AssignGroups,
    GrafokettInput,
    Modal,
  },
  data() {
    return {
      printerName: "",
      ip: "",
      port: "9100",
      groups: [],
      printerToBeEdited: {},
      existingGroups: [],
      groupsToBeAdded: [],
      groupsToBeRemoved: [],
      componentKey: 0,
      showDeleteModal: false,
      deleteModalType: "info",
      deleteModalHeading: "",
      deleteModalText: "",
    };
  },
  methods: {
    hasChangesBeenMade() {
      return (
        this.printerName !== this.printerToBeEdited.name ||
        this.ip !== this.printerToBeEdited.ipAddress ||
        this.groupsToBeAdded.length > 0 ||
        this.groupsToBeRemoved.length > 0
      );
    },
    async getData() {
      await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
      await this.$store.dispatch("PRINTERS/GET_INSTALLED_PRINTERS");

      this.printerToBeEdited = this.$store.getters[
        "PRINTERS/INSTALLED_PRINTERS"
      ].find(p => p.id === parseInt(this.$route.params.id));

      this.printerName = this.printerToBeEdited.name;
      this.ip = this.printerToBeEdited.ipAddress;
      this.port = this.printerToBeEdited.port;

      this.groups = this.printerToBeEdited.groups.map(p => {
        return {
          ...p,
          checked: p.defaultPrinterId === this.printerToBeEdited.id,
        };
      });

      this.existingGroups = this.groups.map(g => ({ ...g }));
      this.componentKey++;
    },
    async deletePrinter() {
      const { data } = await this.$store.$api.get(
        `/api/printers/${this.printerToBeEdited.id}/usage`
      );
      if (!data.data.length > 0) {
        await this.$store.$api.delete(
          `/api/printers?printerId=${this.printerToBeEdited.id}`
        );
        this.loading = false;
        this.deleteModalType = "success";
        this.deleteModalHeading = "Success";
        this.deleteModalText = "Successfully deleted printer!";
        this.showDeleteModal = true;
      } else {
        this.loading = false;
        this.deleteModalType = "error";
        this.deleteModalHeading = "Error";
        this.deleteModalText =
          "This printer can't be removed because it has been printed.";
        this.showDeleteModal = true;
      }
    },
    async postPrinter() {
      if (!this.hasChangesBeenMade) return;

      const payload = {
        printerId: this.printerToBeEdited.id,
        name: this.printerName,
        ipAddress: this.ip,
        port: this.port,
      };

      const groupsWithChangedDefaultPrinter = this.existingGroups
        .filter(g =>
          this.groups.find(
            group => group.id === g.id && group.checked !== g.checked
          )
        )
        .map(g => ({ groupId: g.id, defaultForGroup: g.checked }));

      const groupPayload = {
        printerId: this.printerToBeEdited.id,
        groupsToBeAdded: this.groupsToBeAdded.map(g => ({
          groupId: g.id,
          defaultForGroup: g.checked,
        })),
        groupsToBeRemoved: this.groupsToBeRemoved,
        groupsWithChangedDefaultPrinter,
      };
      try {
        await this.$store.dispatch("PRINTERS/EDIT", payload);
        await this.$store.dispatch("PRINTERS/EDIT_GROUPS", groupPayload);
      } catch (error) {
        console.error(error);
      }
    },
    addGroup(group) {
      if (this.groupsToBeRemoved.find(g => g === group.id)) {
        this.groupsToBeRemoved = this.groupsToBeRemoved.filter(
          g => g !== group.id
        );
      } else {
        this.groupsToBeAdded.push(group);
      }
    },
    removeGroup(group) {
      if (this.existingGroups.find(g => g.id === group.id)) {
        this.groupsToBeRemoved.push(group.id);
      }

      if (this.groupsToBeAdded.find(g => g.id === group.id)) {
        this.groupsToBeAdded = this.groupsToBeAdded.filter(
          g => g.id !== group.id
        );
      }
    },
  },
  computed: {
    availableGroups() {
      return this.$store.getters["GROUPS/GROUPS"];
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="postcss">
.printer-view {
  @apply m-8;
}
</style>
